import { FC } from "react";
import HotelSelectContent from "../../HotelSelectContent/HotelSelectContent";

const LocationComponentWeb: FC<any> = ({ icon: Icon, hasError, ...props }) => {
  return (
    <div className="text-font-default! flex w-full min-w-0 max-w-full flex-1 items-center gap-1 px-1 md:w-full">
      <div className={hasError ? "text-font-danger" : "text-icon-minimal"}>
        <Icon className="h-4! w-4!" />
      </div>
      <HotelSelectContent icon={Icon} {...props} />
    </div>
  );
};

export default LocationComponentWeb;
